import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductDisplayPageBody as ProductDisplayPageAssembly } from "../ProductPageBody";

export const ProductDisplayPageBody = (
    props: Immutable<
        Pick<
            templates.ProductDisplayPageTemplate,
            "page" | "reviews" | "change_root_ssr" | "root_conditional_ssr"
        >
    >,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    return (
        <ProductDisplayPageAssembly
            value={props.page.body.value}
            reviews={props.reviews}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
        />
    );
};
